var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('c-technologies-split',{attrs:{"invert-mobile":"","top-divider":"","image-fill":""}}),_c('c-cta',{attrs:{"split":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }